import { useQuery, UseQueryResult } from '@tanstack/react-query';
import { AxiosError } from 'axios';
import { AppConfig } from '../interfaces/appIntegration.interfaces';
import { getGatewayForApp } from '../../../gateways/gatewayRegistry';
import { useAppSelector } from '../../../redux/hooks/redux';
import { selectCurrentCompany } from '../../../redux/features/user/selectors/userState.selectors';

export interface AppDetails {
  [key: string]: any;
}

export interface useDetailsEndpointResult extends Omit<UseQueryResult<AppDetails, AxiosError>, 'refetch'> {
  refetch: () => Promise<any>;
}

export const useDetailsEndpoint = (app: AppConfig | null): useDetailsEndpointResult => {
  const company = useAppSelector(selectCurrentCompany);
  const companyId = company?.id;

  const {
    data: details,
    isLoading: loading,
    error,
    refetch: tanstackRefetch,
  } = useQuery<AppDetails, AxiosError>({
    queryKey: ['appDetails', app?.id],
    queryFn: async () => {
      if (!app) {
        throw new Error('App not provided');
      }

      if (!app.endpoints?.details) {
        throw new Error('Details endpoint not configured for this app');
      }

      const axiosInstance = getGatewayForApp(app.id);
      console.log(axiosInstance)
      const response = await axiosInstance.get<AppDetails>(app.endpoints.details, {
        headers: {
          "x-company-id": companyId,
        },
      });
      return response.data;
    },
    enabled: !!(app && app.endpoints?.details),
    staleTime: 0,
    gcTime: 0,
    retry: 0,
  });

  const refetch = async () => {
    const result = await tanstackRefetch();
    return result;
  };

  return {
    data: details || null,
    isLoading: loading,
    error: error,
    refetch,
  } as useDetailsEndpointResult;
};